module.exports = __webpack_public_path__ + "img/disan.cda7d2ab.png";